import { render } from "./SearchResultsContact.vue?vue&type=template&id=78530a64&scoped=true"
import script from "./SearchResultsContact.vue?vue&type=script&lang=js"
export * from "./SearchResultsContact.vue?vue&type=script&lang=js"

import "./SearchResultsContact.vue?vue&type=style&index=0&id=78530a64&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78530a64"]])

export default __exports__